import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.9867 2.66675C8.62666 2.66675 2.66666 8.64008 2.66666 16.0001C2.66666 23.3601 8.62666 29.3334 15.9867 29.3334C23.36 29.3334 29.3333 23.3601 29.3333 16.0001C29.3333 8.64008 23.36 2.66675 15.9867 2.66675ZM25.2267 10.6667H21.2933C20.8667 9.00008 20.2533 7.40008 19.4533 5.92008C21.9067 6.76008 23.9467 8.46675 25.2267 10.6667ZM16 5.38675C17.1067 6.98675 17.9733 8.76008 18.5467 10.6667H13.4533C14.0267 8.76008 14.8933 6.98675 16 5.38675ZM5.68 18.6667C5.46666 17.8134 5.33333 16.9201 5.33333 16.0001C5.33333 15.0801 5.46666 14.1867 5.68 13.3334H10.1867C10.08 14.2134 10 15.0934 10 16.0001C10 16.9067 10.08 17.7867 10.1867 18.6667H5.68ZM6.77333 21.3334H10.7067C11.1333 23.0001 11.7467 24.6001 12.5467 26.0801C10.0933 25.2401 8.05333 23.5467 6.77333 21.3334ZM10.7067 10.6667H6.77333C8.05333 8.45341 10.0933 6.76008 12.5467 5.92008C11.7467 7.40008 11.1333 9.00008 10.7067 10.6667ZM16 26.6134C14.8933 25.0134 14.0267 23.2401 13.4533 21.3334H18.5467C17.9733 23.2401 17.1067 25.0134 16 26.6134ZM19.12 18.6667H12.88C12.76 17.7867 12.6667 16.9067 12.6667 16.0001C12.6667 15.0934 12.76 14.2001 12.88 13.3334H19.12C19.24 14.2001 19.3333 15.0934 19.3333 16.0001C19.3333 16.9067 19.24 17.7867 19.12 18.6667ZM19.4533 26.0801C20.2533 24.6001 20.8667 23.0001 21.2933 21.3334H25.2267C23.9467 23.5334 21.9067 25.2401 19.4533 26.0801ZM21.8133 18.6667C21.92 17.7867 22 16.9067 22 16.0001C22 15.0934 21.92 14.2134 21.8133 13.3334H26.32C26.5333 14.1867 26.6667 15.0801 26.6667 16.0001C26.6667 16.9201 26.5333 17.8134 26.32 18.6667H21.8133Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
